// Poll only while the tab is visible; refresh once right away when it becomes visible again. Returns a cleanup function.
export function visiblePoll(fn, ms) {
  let id = null;
  const start = () => { if (id == null) id = setInterval(fn, ms); };
  const stop = () => { if (id != null) { clearInterval(id); id = null; } };
  const onVis = () => { if (document.hidden) stop(); else { fn(); start(); } };
  if (!document.hidden) start();
  document.addEventListener("visibilitychange", onVis);
  return () => { stop(); document.removeEventListener("visibilitychange", onVis); };
}
